<template>
  <GModal name="modal" class="modal modal-exceed-max-products">
    <div slot="header">
      <div class="modal-title">
        <div class="text-red">Keranjang penuh</div>
        <div class="title">Kamu bisa belanja maksimal 4 produk</div>
      </div>
    </div>
    <div slot="body">
      <div class="return" @click="$emit('close')">
        <span>Kembali</span>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'ModalExceedMaxProducts',
};
</script>
